<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <div class="vx-row pt-2">
        <vs-button size="small" class="mr-2 px-3" color="success" type="filled" icon-pack="feather" icon="icon-edit" @click="editRecord">Edit</vs-button>
        <vs-button size="small" class="mr-2 px-3" color="warning" type="border" :disabled="params.context.componentParent.savingVisibility" @click="params.toggleVisibility(params.data)">{{ params.data.is_hidden ? 'Show' : 'Hide' }}</vs-button>
        <vs-button size="small" class="px-3" color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">{{$i18n.t('Delete')}}</vs-button>
      </div>
      <!-- <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" /> -->
    </div>
</template>

<script>
import i18n from '@/i18n/i18n'

export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.params.showAccounts(this.params.data)
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: i18n.t('Warning'),
        text: `${i18n.t('DeleteNotes')} "${this.params.data.name}" dari tahun buku ${localStorage.getItem('selectedYear')}? Account hanya dapat dihapus jika belum memiliki transaksi, saldo, archive, atau sub-account.`,
        accept: this.deleteRecord,
        acceptText: i18n.t('Delete'),
        cancelText: i18n.t('Cancel')
      })
    },
    deleteRecord () {

      this.$store.dispatch('accounts/deleteAccount', this.params.data.id)
        .then(() => {
          this.params.refreshAccounts()
          this.showDeleteSuccess()
        })
        .catch(err => {
          const response = err && err.response && err.response.data
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: (response && response.message) || 'Account tidak dapat dihapus.'
          })
        })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: i18n.t('Success'),
        text: i18n.t('DeleteSuccess')
      })
    }
  }
}
</script>
